<template>
  <div class="leftNav">
    <router-link to="/main">
      <div class="menuBtn" @click="clickNavMenu">
        <v-icon>{{icons[0]}}</v-icon>Home
      </div>
    </router-link>
    <div class="menuBtn" @click="clickCampaign">
        <v-icon>{{icons[1]}}</v-icon>Campaign
    </div>
    <transition name="fade">
      <sub-nav :clickNavMenu="clickNavMenu" v-if="viewNav()"></sub-nav>
    </transition>
    <!-- <div class="admin_menu" v-if="userType">
      <button @click="setOpenGangnam">광동비타500</button>
    </div> -->
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { getInfo } from '@/assets/func'
  import SubNav from './SubNav'

  export default {
    name: 'leftNav',
    props: {
      clickNavMenu: Function
    },
    components: {
      SubNav
    },
    data () {
      return {
        icons: ['home', 'view_list']
      }
    },
    methods: {
      ...mapMutations([
        'setCurrentPageNum',
        'setListStatus',
        'setSearchKey'
        // 'setOpenGangnam'
      ]),
      clickCampaign () { // 캠페인 리스트 진입, 초기화 - pNum = 1, status='진행', 검색어=''
        this.setCurrentPageNum(1)
        this.setListStatus(2)
        this.setSearchKey('')
        this.clickNavMenu()
        this.$router.push('/campaignlist')
      },
      viewNav () {
        return this.$parent.$route.path === '/campaign' || this.$parent.$route.path.indexOf('/campaign/') > -1
      }
    },
    computed: {
      userType () {
        return getInfo().cust_knd === 'S'
      }
    }
  }

</script>

<style scoped>
  .leftNav {
    z-index: 99;
    position: fixed;
    width: 150px;
    background-color: #fff;
    top: 51px;
    height: calc(100vh - 53px);
    margin-top: 2px;
    border-right: 2px solid #eaeaea;
    min-height: 500px;  /* 나중에 수정 */
  }

  .menuBtn {
    height: 50px;
    line-height: 50px;
    font-weight: 500;
    left: 0;
    width: calc(100% - 10px);
    display: flex;
    justify-content: flex-start;
    padding-left: 10px;
    align-items: center;
    border-bottom: .2em solid #eaeaea;
    color: #505050;
  }
  .menuBtn:hover {
    background: rgb(247, 249, 250);
    cursor: pointer;
  }
  .menuBtn i {
    color: #689f38;
    margin-right: 10px;
    font-size: 23px;
    vertical-align: middle;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all .3s ease;
  }

  .fade-enter,
  .fade-leave-to{
    transform: translateX(-30px);
    opacity: 0;
  }
  .icon.list {
    font-size: 25px;
  }

  @media screen and (max-width: 800px) {
    .leftNav {
      top: 40px;
      height: calc(100vh - 40px);
      border-right: 2px solid #eaeaea;
    }
  }

  .admin_menu {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    width: 85px;
  }
</style>


// WEBPACK FOOTER //
// LeftNav.vue?21dc32bc